<!-- 通用下拉组件 （接口数据返回）

    props 
      'apiPath':       String, 必传; 接口地址
      'params':        Object, 非必传; 请求接口的参数
      'keys':          Object, 非必传; 定义返回值的key

      'defaultVal':    String, 非必传; 默认选中值; 多个默认选中值逗号拼接, '多选'模式下才会生效
      'selectFirst':   Boolean, 非必传; 是否选中第一条记录, 默认不选中, '单选'模式且无默认值的情况下才会生效
     
      'method':        String,  非必传; ajax请求方式，默认get

    callback
      change(value): 切换选中节点

 -->
<template>
  <el-select class="select_common"
    v-model="myDefaultVal" @change="handleChange"
    :maxTagCount="1" :maxTagTextLength="10" v-bind="$attrs">
    <template v-if="list">
      <el-option v-for="item in list" :key="item[keys.value]" :value="item[keys.value]" :label="item[keys.label] "> </el-option>
    </template>
  </el-select>
</template>

<script>

import { mapGetters } from "vuex"
import { API__common,  } from '@/api/index.js'

export default {
  name: "Organization",
  inheritAttrs: false,
  props: {
    apiPath: {       // 接口地址
      type: String,
    },

    params: {        // 请求接口的参数
      type: Object,
      default: () => { },
    },

    keys: {        // 定义返回值的key
      type: Object,
      default: {label: 'label', value: 'value'},
    },
  
    defaultVal: {  // 默认值
      type: String,
      default: undefined
    },

    defaultValDisabled: {  // 默认值禁止取消操作
      type: Boolean,
      default: false,
    },
    
    selectFirst: {  // 是否需要默认选中第一条记录
      type: Boolean,
      default: false,
    },
    
    // ajax请求方式
    method: {
      type: String,
      default: 'post'
    },
    
  },
  data () {
    return {
      myDefaultVal: this.defaultVal ? this.defaultVal : '',

      list: [],   // 下拉列表

    };
  },

  computed: {
    ...mapGetters(['userInfo', ]),
  },


  created() {},

  mounted() {
    this.getList();
  },

  methods: {

    handleChange(value) {
      if(typeof value == 'string') {
        value = [value];
      }
      let datas = [];
      if(value) {
        datas = this.list.filter( item => value.indexOf( item[this.keys.value] ) > -1 );
      }
      // console.log('commons_select...change...', value, datas);
      this.$emit('change', value || '', datas);
    },

    // 获取列表
    getList() {
      
      let params = {
        token: this.userInfo.phone,
        checkCode: this.userInfo.checkCode
      }

      params = {...params, ...this.params }
      API__common.getSelectCommonList(this.apiPath, params, this.method).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.records? res.data.data.records: res.data.data;
          if(this.selectFirst  && !this.defaultVal) {
            this.myDefaultVal = this.list[0][this.keys.value];
            this.handleChange(this.myDefaultVal);
          }
        }
      }).catch(e => {
        // this.$antd_message.error("网络比较慢，请您稍后再试...");
      });
    },

  },

  watch: {
    'defaultVal': function() {
      // console.log('this.myDefaultVal...11..', this.defaultVal, this.myDefaultVal);
      this.myDefaultVal = this.defaultVal ? this.defaultVal : '';
      // console.log('this.myDefaultVal..22...', this.myDefaultVal, this.myDefaultVal.length);
    },

  }

}
</script>

<style lang='scss' scoped>

</style>



// WEBPACK FOOTER //
// SelectCommon.vue?a67b3cf8